import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Router, Route, Redirect, Switch } from 'react-router-dom';
import thunk from 'redux-thunk';
import logger from 'redux-logger';

// Import reducers
import * as reducers from './reducers';

// Import Session actions
import {Session} from './actions/index';

// Import containers
import Portal from './containers/pages/auth/Portal';
import Home from './containers/pages/user/Home';
import Io from './containers/components/Io';

import Trackmanager from './containers/pages/artist/management/Tracks';

// Create history objects
import createHistory from 'history/createBrowserHistory';
let history = createHistory();

// Create store
const createStoreWithMiddleware = applyMiddleware(thunk, logger)(createStore);
const reducer = combineReducers(reducers); // Register all reducers
const store = createStoreWithMiddleware(reducer); // Create the store middleware

// import authenticateRoute function
const {authenticateRoute} = Session.actions;

function View({component: Component, ...rest}) {
  return rest.level ? (
    <Route {...rest} render={renderProps => (
      authenticateRoute(rest.path, rest.level, history) ? (
        <Component {...renderProps} />
      ) : (
        <Redirect to={ {
          pathname: rest.redirect || '/portal',
          state: {from: renderProps.location}
        } } />
      )
    )}/>
  ) : (
    <Route {...rest} render={renderProps => (
      (<Component {...renderProps} />)
    )}/>
  )
}

class App extends Component {
  render() {
    return (
      <Router history={history}>
        <Provider store={store}>
          <div>
            <Switch>
              <View exact path='/portal'        component={Portal} />
              <View exact path='/'              component={Home}         level={1} />
              <View exact path='/artist/tracks' component={Trackmanager} level={2} redirect='/' />
            </Switch>
            <Io />
          </div>
        </Provider>
      </Router>
    );
  }
}

export default App;
export {store};



// WEBPACK FOOTER //
// ./src/App.js